import type { LiHTMLAttributes } from "react";
import cx from "classnames";

const AiAssistantExpandableTreeItem = ({
  children,
  className,
  style,
  branchYOffset,
  ...props
}: LiHTMLAttributes<HTMLLIElement> & { branchYOffset?: string }) => (
  <li
    className={cx("gap-1 py-1 pl-6", className)}
    style={
      branchYOffset
        ? ({ ...style, "--_branch-y": branchYOffset } as React.CSSProperties)
        : style
    }
    {...props}
  >
    {children}
  </li>
);

export default AiAssistantExpandableTreeItem;
